import {
  blue,
  ChangeIndicatorBadge,
  FaroButton,
  FaroButtonSizes,
  FilterIcon,
} from "@faro-lotv/flat-ui";
import { SvgIconProps } from "@mui/material";
import { useCallback, type JSX } from "react";

export type FilterToggleProps = {
  /** true if the toggle is checked */
  isChecked: boolean;

  /** true if at least one filter is defined */
  hasFilters: boolean;

  /** Whether to show button text or not */
  showButtonText: boolean;

  /** notify the user clicked on the toggle */
  onToggle(checked: boolean): void;
};

/** @returns a toggle to show/hide the row with annotations filters */
export function FilterToggle({
  isChecked,
  hasFilters,
  showButtonText,
  onToggle,
}: FilterToggleProps): JSX.Element {
  const reportToggle = useCallback(() => {
    onToggle(!isChecked);
  }, [isChecked, onToggle]);

  return (
    <FaroButton
      aria-label="Filters button"
      sx={{ color: "black", minWidth: "32px" }}
      size={FaroButtonSizes.s}
      variant="ghost"
      onClick={reportToggle}
      icon={
        <FilterToggleIcon
          hasFilters={hasFilters}
          sx={{ width: "16px", height: "16px" }}
        />
      }
    >
      {showButtonText && "Filters"}
    </FaroButton>
  );
}

/** @returns the toggle icon with an optional badge if filters are defined */
function FilterToggleIcon({
  hasFilters,
  ...props
}: Pick<FilterToggleProps, "hasFilters"> & SvgIconProps): JSX.Element {
  return (
    <ChangeIndicatorBadge
      color={blue[400]}
      showZero={false}
      badgeContent={hasFilters ? 1 : 0}
    >
      <FilterIcon {...props} />
    </ChangeIndicatorBadge>
  );
}
